import PdfPreview from '../pdfPreview'
import { Image, ImageProps } from 'antd'
import { EFileType } from 'enums'
import { ReactNode, useEffect, useState } from 'react'
import { useFileService } from 'services'
import styled from 'styled-components'

const StyleContainer = styled.div`
  color: var(--color-primary-primary);
  cursor: pointer;
`
interface IProps extends ImageProps {
  imageId?: number
  url?: string
  name?: string
  label?: ReactNode
  fileType?: EFileType
  className?: string
}

const GetImagePdf = (props: IProps) => {
  const { getUrlFile } = useFileService()
  const {
    imageId,
    url,
    fileType = EFileType.Img,
    name,
    className,
    ...resProps
  } = props
  const [urlImage, setImage] = useState('')

  const handleGetImage = () => {
    if (imageId) {
      getUrlFile(imageId).then((res) => {
        if (res._successfully) {
          setImage(res?.data?.public_access_url)
        }
      })
    }
  }

  useEffect(() => {
    handleGetImage()
  }, [imageId])

  return (
    <StyleContainer className={className}>
      {fileType !== EFileType.Pdf && (
        <Image src={url || urlImage} {...resProps} />
      )}
      {fileType === EFileType.Pdf && (
        <PdfPreview src={url} previewTitle={name} />
      )}
    </StyleContainer>
  )
}
export default GetImagePdf
